<nav class="site-nav" [class.scrolled]="scrolled()" id="site-nav">
  <div class="nav-inner">
    <a routerLink="/" class="flex items-center" aria-label="Advanced Rent home" (click)="closeMenu()">
      <img src="images/advanced-rent-logo-dark.png" alt="Advanced Rent" class="h-8 w-auto" width="200" height="32" />
    </a>

    <ul class="nav-links">
      @for (link of primaryNav; track link.path) {
        <li>
          <a [routerLink]="link.path" routerLinkActive="active">{{ link.label }}</a>
        </li>
      }
    </ul>

    <div class="nav-cta">
      <a href="tel:01603558180" class="btn-ghost">Call 01603 558 180</a>
      <a routerLink="/rent-guarantee-insurance" class="btn-accent">Get a quote</a>
    </div>

    <button
      type="button"
      class="rounded-md p-2 text-primary lg:hidden"
      (click)="toggleMenu()"
      [attr.aria-expanded]="menuOpen()"
      aria-label="Toggle menu"
    >
      <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        @if (menuOpen()) {
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        } @else {
          <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
        }
      </svg>
    </button>
  </div>

  @if (menuOpen()) {
    <div class="border-t border-border-default bg-white lg:hidden">
      <div class="container-page space-y-1 py-4">
        @for (link of primaryNav; track link.path) {
          <a
            [routerLink]="link.path"
            routerLinkActive="bg-warm-white"
            (click)="closeMenu()"
            class="block rounded-md px-3 py-2 text-sm font-medium text-primary hover:bg-warm-white"
          >{{ link.label }}</a>
        }
        <div class="mt-3 flex flex-col gap-2">
          <a href="tel:01603558180" class="btn-ghost w-full">Call 01603 558 180</a>
          <a routerLink="/rent-guarantee-insurance" (click)="closeMenu()" class="btn-accent w-full">Get a quote</a>
        </div>
      </div>
    </div>
  }
</nav>
